import React from "react";
import ChatContainer from "../../component/chatContainer/ChatContainer";
import "./chatPage.css";

const ChatPage = ({
  handleSubmit,
  setIsFocused,
  inputRef,
  value,
  setValue,
  showCrossIcon,
  handlePause
}) => {
  return (
    <div className="chat-page">
      <ChatContainer
        handleSubmit={handleSubmit}
        setIsFocused={setIsFocused}
        inputRef={inputRef}
        value={value}
        setValue={setValue}
        showCrossIcon={showCrossIcon}
        handlePause={handlePause}
      />
    </div>
  );
};

export default ChatPage;
